import { FC } from 'react';

import SparkSnapsPanel from '@features/spark-snaps/components/SparkSnapsPanel';

import { useApp } from '@hooks/AppHooks';
import { useSpark } from '@hooks/SparksHooks';

import './SparkWizardSnapPanel.scss';

interface SparkWizardSnapPanelProps {}

const SparkWizardSnapPanel: FC<SparkWizardSnapPanelProps> = () => {
    const { REACT_APP_SPARK_SNAPS } = process.env;
    const { spark, updateSpark } = useSpark();
    const { userIsSuperAdmin } = useApp();
    const handleUpdateSparkSnaps = async (params: {
        accountId: string;
        storifymeAccountId: string;
        snapIds: number[];
    }) => {
        updateSpark({
            snaps: params,
        });
    };

    const sparkSnapsAreEnabled = REACT_APP_SPARK_SNAPS === 'true' || userIsSuperAdmin;
    if (!sparkSnapsAreEnabled) {
        return <></>;
    }

    return (
        <SparkSnapsPanel
            sparkId={spark._id}
            accountId={spark?.originatorGroupId ?? spark.groupId}
            initialSnapIds={spark.snaps?.snapIds}
            onChange={handleUpdateSparkSnaps}
        />
    );
};

export default SparkWizardSnapPanel;
